import React from "react";
import PrimaryButton from "../../components/buttons/PrimaryButton";
import MoreVertIcon from '@material-ui/icons/MoreVert';
import {checkForCookieEnabled} from "../../util/CookieEnable";
import config from "../../Config";
import { event } from "../../components/reactGA";

class EnableCookie extends React.Component {
	
	componentWillMount(){
		if(checkForCookieEnabled()){
			event({
                category:"Cookie Page",
                action: "Cookie Enabled"
            });
			window.location.href = config.BILLING_URL;
		} else {
			event({
                category:"Cookie Page",
                action: "Cookie Disabled"
            });
		}
	}

	render(){
		var isChrome = window.navigator.userAgent.indexOf("Chrome") != -1;
		var isSamsungBrowser = window.navigator.userAgent.match(/SamsungBrowser/i);
		// console.log("isOpera -->>",isOpera) 
		// console.log("isSamsungBrowser -->>",isSamsungBrowser)
	
		var browserName = "Google Chrome";
		var step3 = "Click on Site settings";
		var step4 = "Click on Cookies and allow site to save and read cookies data";
		if(isSamsungBrowser){
			browserName = "Samsung Browser";
			step3 = "Click on Privacy";
			step4 = "Tab on accept Cookies";
		}
		return <div className="card montserratRegular">
			<h3>Please Allow Cookies of your browser to access Bidnwin services.</h3>
			<h4>For {browserName}:</h4>
			<br/>                
			<div>
				Step 1: <span>Click on <MoreVertIcon style={{fontSize:12}}/> in the top right</span>;
		        <br />
		        Step 2: Go to Settings
		        <br />
		        Step 3: {step3}
		        <br />
		        Step 4: {step4}
		        <br />
		        Step 5: Reload the page
			</div> 
			<br/>
	    		For other browsers, please switch off from the Settings menu.
	        <br/>
	        <br/>
	        <div className="text-center">
	        	<PrimaryButton
	        		label="Reload"
	        		onClick={()=> window.location.reload(true)}
	        	/>
	        </div>               
		</div>
	}
}

export default EnableCookie;


// WEBPACK FOOTER //
// ./src/views/EnableCookie/index.js